import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { LoginService } from '@shared-angular/services/login.service';
import { BotService } from './../services/bot.service';

export const botprotectResolver: ResolveFn<boolean> = async (route) => {
  const loginService: LoginService = inject(LoginService);
  const botService: BotService = inject(BotService);
  // persist=false: Token wird erst nach Bestaetigung des Datenschutzhinweises in BotBasedComponent persistiert
  const user = await loginService.loadMyUser(false);

  if (user == null) {
    return false;
  } else {
    const id = route.params['id'] as string;
    return await botService.hasBotAccessByAdmin(id);
  }
};
